import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=1f75b327&scoped=true&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"
import style1 from "./Contact.vue?vue&type=style&index=1&id=1f75b327&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f75b327",
  null
  
)

export default component.exports